import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { body, bodySmall, poppinsSemiBoldFont } from '@/styles/typography';
import styled from 'styled-components';
import { ButtonType } from './ButtonNew';

export const ButtonWrapper = styled.button<ButtonType>`
  position: relative;
  ${flex({ justifyContent: 'center', alignItems: 'center' })};
  ${poppinsSemiBoldFont};
  ${bodySmall};
  text-align: center;
  padding: 10px 18px;
  border-style: none;
  border-radius: 8px;
  color: ${COLORS.white};
  background-color: ${COLORS.green[500]};
  width: ${({ width }) => width ?? 'auto'};
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: ${COLORS.green[450]};
  }

  &:disabled {
    color: ${COLORS.grey[600]};
    background-color: ${COLORS.grey[300]};
    cursor: not-allowed !important;
    border: none !important;
    pointer-events: none;
  }

  ${media.mobile`
    ${({ mobileStretch }) =>
      mobileStretch &&
      `
      width: 100%;
    `};
  `}

  ${({ size }) =>
    size === 'large' &&
    `
    ${body};
    padding: 14px 18px;
  `};

  ${({ variant }) =>
    variant === 'secondary' &&
    `
    color: ${COLORS.black};
    background-color: ${COLORS.white};
    border: 1px solid ${COLORS.grey[400]};

    &:hover {
      background: ${COLORS.grey[50]};
    }
  `};

  ${({ variant }) =>
    variant === 'danger' &&
    `
    color: ${COLORS.white};
    background-color: ${COLORS.red[450]};
    border: 1px solid ${COLORS.red[450]};

    &:hover {
      background: ${COLORS.red[500]};
    }
  `};
`;
